import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CcaRateChartAreaDatagrid from "./CcaRateChartAreaDatagrid";
import { useEffect, useState } from "react";
import { SelectInput, required, useDataProvider, useNotify } from "react-admin";
import { useField } from "react-final-form";
import { ccaRateChartType, ccaRateChartTypeOptions } from "../const";
import CustomNumberInput from "components/CustomNumberInput";

const CostPerTripBasedOnArea = ({ ccaAreas, isEdit, isDisabled }: any) => {
  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Area Pricing (Exclusive of GST)</Typography>
      </Grid>

      <Grid item xs={6}>
        <Grid item xs={12}>
          <CcaRateChartAreaDatagrid
            ccaAreas={ccaAreas}
            edit={isEdit}
            isDisabled={isDisabled}
          />
        </Grid>
      </Grid>
    </SanitizedGrid>
  );
};

const CcaRateChartTypeInput = ({
  schoolId,
  ccaRateChartId,
  isDisabled = false,
  isEdit = false,
}: any) => {
  const [ccaAreas, setCcaAreas] = useState<IArea[]>([]);

  const provider = useDataProvider();
  const notify = useNotify();
  const ccaRateChartTypeField = useField("ccaRateChartType");

  // Only use for update case
  const riderPriceField = useField("riderPrice");
  const nonRiderPriceField = useField("nonRiderPrice");
  const priceField = useField("price");

  //fetch area data for current school when schoolId is changed
  useEffect(() => {
    if (schoolId !== undefined) {
      provider
        .getList("ccaAreas", {
          filter: { SchoolId: schoolId },
          pagination: {
            page: 1,
            perPage: 1000,
          },
          sort: {
            field: "MaxDistanceInMeters",
            order: "ASC",
          },
        })
        .then((result) => {
          setCcaAreas(result.data as IArea[]);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  // fetch school detail for current school when schoolId is changed
  useEffect(() => {
    if (schoolId !== undefined) {
      provider
        .getOne("schools", { id: schoolId })
        .then(({ data }) => {
          ccaRateChartTypeField.input.onChange(data.ccaRateChartType);
        })
        .catch((error: any) => {
          notify(`Error, ${error.message}`, "error");
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  // get the price for rider, non-rider and price per week depend on the cca rate chart type.
  // use setTimeOut to show the value for input field. Otherwise, it doesn't show properly
  useEffect(() => {
    if (ccaRateChartId !== undefined && isEdit) {
      provider
        .getOne("ccaRateCharts", { id: ccaRateChartId })
        .then(({ data }) => {
          setTimeout(() => {
            switch (ccaRateChartTypeField.input.value) {
              case ccaRateChartType.costPerTripAndStudentType:
                nonRiderPriceField.input.onChange(
                  data.ccaRateChartCostPerTrip.nonRiderPrice.toFixed(2) / 100
                );
                riderPriceField.input.onChange(
                  data.ccaRateChartCostPerTrip.riderPrice.toFixed(2) / 100
                );
                break;
              case ccaRateChartType.costPerWeek:
                priceField.input.onChange(
                  data.ccaRateChartCostPerWeek.price.toFixed(2) / 100
                );
                break;
            }
          }, 100);
        })
        .catch((error: any) => {
          notify(`Error, ${error.message}`, "error");
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ccaRateChartId]);

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={3}>
        <SelectInput
          source="ccaRateChartType"
          label="CCA Rate Chart Type"
          choices={ccaRateChartTypeOptions}
          validate={required()}
          disabled
        />
      </Grid>
      <Grid item xs={9}></Grid>

      <Grid item xs={12}>
        {ccaRateChartTypeField.input.value ===
          ccaRateChartType.costPerTripBasedOnArea && (
          <CostPerTripBasedOnArea
            ccaAreas={ccaAreas}
            isEdit={isEdit}
            isDisabled={isDisabled}
          />
        )}
        {ccaRateChartTypeField.input.value ===
          ccaRateChartType.costPerTripAndStudentType && (
          <SanitizedGrid container spacing={2}>
            <Grid item xs={3}>
              <CustomNumberInput
                label="Rider Price ($)"
                source="riderPrice"
                isRequired
                isPositiveValue
                isDisabled={isDisabled}
              />
            </Grid>
            <Grid item xs={3}>
              <CustomNumberInput
                label="Non-Rider Price ($)"
                source="nonRiderPrice"
                isRequired
                isPositiveValue
                isDisabled={isDisabled}
              />
            </Grid>
          </SanitizedGrid>
        )}
        {ccaRateChartTypeField.input.value === ccaRateChartType.costPerWeek && (
          <SanitizedGrid container spacing={2}>
            <Grid item xs={3}>
              <CustomNumberInput
                label="Price ($)"
                source="price"
                isRequired
                isPositiveValue
                isDisabled={isDisabled}
              />
            </Grid>
          </SanitizedGrid>
        )}
      </Grid>
    </SanitizedGrid>
  );
};

export default CcaRateChartTypeInput;
